/**
 * ScrollProgress — fixed top bar that fills as the page scrolls.
 * Ports the `#progress` scroll-progress bar shared by the AB8 pages.
 */
import { useEffect, useState } from 'react';

export default function ScrollProgress({ color = 'currentColor', height = 3 }) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? (h.scrollTop / max) * 100 : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height, zIndex: 60, pointerEvents: 'none' }}>
      <div style={{ width: `${pct}%`, height: '100%', background: color, transition: 'width .1s linear' }} />
    </div>
  );
}
